var offsetElement = checkWidth(1024) ? 'section div[class^="container"], section.image_text .text-container, section.quilt .text-container' : 'section div[class^="container"], section.image_text .bg-wrapper, section.quilt .quilt-container';

window.addEventListener('load', function() {
	// Remove visibility: hidden; for CLS
	body.style = '';

	var stickyHeader = new Waypoint({
		element: main.querySelector(offsetElement),
		handler: function(direction) {
			var down = direction == 'down';

			if(down)
				body.classList.add('sticky');
			else
				body.classList.remove('sticky');
		},
		offset: header.offsetHeight + (!checkWidth(1200) ? 30 : 0)
	});
});

var lastScrollTop = 0;

window.addEventListener('scroll', function() {
	if(checkWidth(480) && body.classList.contains('sticky') && topbar) {
		var st = window.pageYOffset || document.documentElement.scrollTop;

		if(st > lastScrollTop)
			topbar.classList.add('hide');
		else
			topbar.classList.remove('hide');

		lastScrollTop = st <= 0 ? 0 : st;
	}
});